import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-524ee7fc")

_pushScopeId("data-v-524ee7fc")
const _hoisted_1 = { class: "policy-gate-page d-flex flex-column min-vh-100 bg-light" }
const _hoisted_2 = { class: "policy-gate-header bg-white border-bottom px-4 py-4" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", { class: "fs-2 fw-bold text-gray-900 mb-0" }, "Company Policy", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-muted mb-0 mt-2"
}
const _hoisted_6 = {
  key: 1,
  class: "text-muted mb-0 mt-2"
}
const _hoisted_7 = { class: "policy-gate-content flex-grow-1 container-fluid py-5" }
const _hoisted_8 = { class: "col-xxl-12" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = { class: "policy-gate-footer bg-white border-top shadow-sm" }
const _hoisted_12 = { class: "container-fluid py-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_14 = {
  key: 1,
  class: "d-flex flex-wrap align-items-center gap-3"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "text-danger fw-semibold mb-0" }, " Unable to load your agreement status. Please try again. ", -1)
const _hoisted_16 = {
  key: 2,
  class: "d-flex justify-content-end"
}
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-success fw-semibold mb-3" }, " Before you can proceed, check the box below to confirm you have read and agree to the terms. ", -1)
const _hoisted_19 = { class: "form-check form-check-custom form-check-solid d-flex align-items-start mb-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "form-check-label ms-3" }, " I have read the ALLIANCE IN MOTION GLOBAL, INC. TERMS AND CONDITIONS FOR DISTRIBUTORS. I agree and I want to proceed! ", -1)
const _hoisted_21 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.reviewMode)
          ? (_openBlock(), _createBlock("p", _hoisted_5, " Please read the policy below and agree before continuing. "))
          : (_openBlock(), _createBlock("p", _hoisted_6, " Review the distributor terms and conditions anytime. "))
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("iframe", {
              src: _ctx.policyPdfUrl,
              title: "Company Policy",
              class: "policy-pdf-frame w-100 border-0 rounded"
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        (_ctx.statusLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_13, "Loading agreement status..."))
          : (_ctx.statusError)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary min-w-100px",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadAgreementStatus && _ctx.loadAgreementStatus(...args)))
                }, " Retry "),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-danger min-w-100px",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, " Logout ")
              ]))
            : (_ctx.reviewMode)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-primary min-w-100px",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, " Back ")
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("label", _hoisted_19, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-1",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.termsChecked = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.termsChecked]
                    ]),
                    _hoisted_20
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-info min-w-100px",
                      disabled: !_ctx.termsChecked || _ctx.submitting,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.agreeToCompanyPolicy && _ctx.agreeToCompanyPolicy(...args)))
                    }, [
                      (_ctx.submitting)
                        ? (_openBlock(), _createBlock("span", _hoisted_22, "Please wait..."))
                        : (_openBlock(), _createBlock("span", _hoisted_23, "Proceed"))
                    ], 8, ["disabled"]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-danger min-w-100px",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, " Logout ")
                  ])
                ]))
      ])
    ])
  ]))
})